var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"show-cart-container",class:{'visible': _vm.visible},on:{"click":function($event){return _vm.toggleCartVisibility()}}},[_c('div',{staticClass:"products-counter"},[_vm._v(_vm._s(_vm.productsCounter))]),_vm._v(" "),_c('img',{attrs:{"src":_vm.shopping_cart_white}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-be12c696","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ShowCart.vue
// module id = null
// module chunks = 